export default __webpack_public_path__ + "static/media/search.791bb523.svg";